import { mutateApi, queryApi } from "src/utils/api/ApiMethods"
import { buildQueryString } from "src/utils/api/query_param_helpers"

export const queryActiveIntegration = ({ marinaSlug }) => {
  return queryApi(`/manage/${marinaSlug}/integrations/apideck/consumers`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const createApideckSession = ({ marinaSlug }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/sessions`,
    method: "POST",
  })
}

export const updateApideckConsumer = ({ marinaSlug, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/consumers`,
    method: "PUT",
    data,
  })
}

export const resetApideckConsumer = ({ marinaSlug }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/consumers`,
    method: "DELETE",
  })
}

export const queryInvoiceItems = (marinaSlug) => {
  return queryApi(`/manage/${marinaSlug}/integrations/apideck/invoice_items`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const updateInvoiceItem = ({ marinaSlug, id, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/invoice_items/${id}`,
    method: "PATCH",
    data,
  })
}

export const getApideckInvoices = (marinaSlug, params = {}) => {
  const qs = buildQueryString(params)

  return queryApi(`/manage/${marinaSlug}/integrations/apideck/invoices${qs}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const retryInvoiceSync = ({ marinaSlug, id }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/integrations/apideck/invoices/${id}/retries`,
    method: "POST",
  })
}
